import React from 'react';
import HowItWorks from './HowItWorks';
import WhyFastest from './WhyFastest';
import WhatOurClientSay from './WhatOurClientSay';
import TrustedFinancial from './TrustedFinancial';
import PopularCountry from './PopularCountry';
import LetsBegin from './LetsBegin';
import FooterSection from './FooterSection';
import FastestExchange from './FastestExchange';
import SendMoneyInstntly from './SendMoneyInstntly';

export default function IndexPage() {
    return (
        <div className='max-w-[100vw] object-cover overflow-hidden'>
            <FastestExchange />
            <HowItWorks />
            <SendMoneyInstntly />
            <WhyFastest />
            <WhatOurClientSay />
            <TrustedFinancial />
            <PopularCountry />
            <LetsBegin />
            <FooterSection />
        </div>
    )
}
